import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";
import { Modal, Button, message } from "antd";
import { API_KEY } from "../../config";
import { Loader, LoaderOptions } from "google-maps";

export type Location = {
  lat: number;
  long: number;
}

export type Props = {
  current?: Location;
  locationState: (markerPosition: Location) => any;
  ref?: any;
  style?: object;
};

// let map: google.maps.Map;

const options: LoaderOptions = {
  /* todo */
};

// console.log("API_KEY =>", API_KEY);

const Marker: React.FC<Props> = (props) => {
  const { current = { lat: 0, long: 0 } } = props;

  const [currentLocation, setCurrentLocation] = useState<any>({
    lat: 0,
    long: 0,
  });
  
  const removeDuplicateScript = () => {
    const head = document.getElementsByTagName('head')[0]
    const headScripts = head.getElementsByTagName('script')
    const scripts = Array.from(headScripts)
    const format = `https://maps.googleapis.com/maps/api/js?callback=_dk_google_maps_loader_cb&key=${API_KEY}`
    const dups = scripts.filter(tag => tag.src?.includes(format))

    if (dups.length > 1) {
      dups.forEach((tag: any, index: number) => {
        if (index > 0) head.removeChild(tag)
      })
    }
  }

//   const format = `https://maps.googleapis.com/maps/api/js?callback=_dk_google_maps_loader_cb&key=AIzaSyD4xHcwbP4G7ZqqPCFN_i1zKKyM_eIfY0w`
// Array.from(document.getElementsByTagName('script')).filter(tag => tag.src?.includes(format))

  const initMap = async () => {
    const loader = new Loader(API_KEY, options);
    const google = await loader.load();
    removeDuplicateScript();

    let lat = currentLocation.lat;
    let lng = currentLocation.long;
    if (current.lat && current.long) {
      lat = current.lat;
      lng = current.long;
    }

    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        center: { lat, lng },
        zoom: 12,
        disableDefaultUI: true,
        zoomControl: true,
      }
    );

    const myMarker = new google.maps.Marker({
      position: map.getCenter(),
      animation: google.maps.Animation.DROP,
      draggable: true,
      map: map,
      // icon: {
      //   path: google.maps.SymbolPath.CIRCLE,
      //   scale: 10,
      // },
    });

    google.maps.event.addListener(myMarker, "dragend", function (evt: any) {
      // document.getElementById('current').innerHTML = '<p>Marker dropped: Current Lat: ' + evt.latLng.lat().toFixed(3) + ' Current Lng: ' + evt.latLng.lng().toFixed(3) + '</p>';
      // console.log(
      //   "position drop =>",
      //   `${evt.latLng.lat()}, ${evt.latLng.lng()}`
      // );
      const position = {
        lat: evt.latLng.lat(),
        long: evt.latLng.lng(),
      };

      props.locationState(position);
    });
  };

  const showPosition = (position: any) => {
    const lat = position.coords.latitude;
    const long = position.coords.longitude;

    // console.log("type of =>", typeof lat);

    // console.log(`${lat}, ${long}`);

    const pos = {
      lat,
      long,
    };

    props.locationState(pos);

    setCurrentLocation({
      lat,
      long,
    });
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      // console.log("get location...");

      navigator.geolocation.getCurrentPosition(showPosition);

      // console.log("get location next.");
    } else {
      const msg = "Geolocation is not supported by this browser.";
      // console.log("Geolocation is not supported by this browser.!!!");
      message.warning(msg);
    }
  };

  useEffect(() => {
    if (currentLocation.lat && currentLocation.long) {
      // console.log("has currentLocation =>", currentLocation);

      initMap();
    }
  }, [currentLocation]);

  // useEffect(() => {
  //   console.log("current=>>>>>", props.current);

  //   if (props.current.lat && props.current.long) {
  //     console.log('has props.current =>', props.current);

  //     initMap();
  //   }
  // }, [props.current]);

  useEffect(() => {
    // setTimeout(() => {
    //   console.log('init map...');
    //   initMap();
    // }, 0);

    // TODO: get default location

    // console.log("current =>", current);

    if (!current.lat || !current.long) {
      getLocation();
    } else {
      initMap();
    }
  }, []);

  return (
    <>
      <div id="map" className={styles.map} style={props.style}></div>
      {/* <Button type="primary" onClick={showModal}>
        ค้นหาร้านค้า
      </Button>
      <Modal
        title="ค้นหาร้านค้า"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="ค้นหาร้านค้า"
        cancelText="ยกเลิก"
      >
        <div id="map" className={styles.map}></div>
      </Modal> */}
    </>
  );
};
export default Marker;
